/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Submissions } from '../../models/submissions';

export interface UpdateSubmissionStatusApiV2SubmissionsOrgIdStatusPatch$Params {
  id: string;
  org: string;
  action: 'start' | 'complete' | 'reopen';
}

export function updateSubmissionStatusApiV2SubmissionsOrgIdStatusPatch(http: HttpClient, rootUrl: string, params: UpdateSubmissionStatusApiV2SubmissionsOrgIdStatusPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<Submissions>> {
  const rb = new RequestBuilder(rootUrl, updateSubmissionStatusApiV2SubmissionsOrgIdStatusPatch.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('org', params.org, {});
    rb.query('action', params.action, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Submissions>;
    })
  );
}

updateSubmissionStatusApiV2SubmissionsOrgIdStatusPatch.PATH = '/api/v2/submissions/{org}/{id}/status';
